(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-items"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('input', e => {
		if(e.target.classList.contains('quanty')) {
			const inputField = e.target;
			key = inputField.dataset.line;
			currentValue = parseInt(inputField.value);

			// Call Shopify API to update cart
			updateShopifyCart(key, currentValue);
		}
	});

	document.addEventListener('click', e => {
		if(e.target.classList.contains('cart__remove')) {
			e.preventDefault();
			updateShopifyCart(e.target.dataset.key, 0);
		}
		if(e.target.classList.contains('remove_subscription')) {
			e.preventDefault();
			removeSubscription(e.target.dataset.key, e.target.dataset.sub, e.target.dataset.pdf);
		}
		if(e.target.classList.contains('qty__adjust') && e.target.closest('.cart_wrap')) {
			e.preventDefault();
			inputField = e.target.closest(".g_prod_qty").querySelector("input.quanty"),
			key = inputField.dataset.line;
			currentValue = parseInt(inputField.value) || 1;

			var newValue = e.target.classList.contains("qty__adjust--plus") ? currentValue + 1 : Math.max(currentValue - 1, 0);

			inputField.value = newValue;

			// Call Shopify API to update cart
			updateShopifyCart(key, newValue);
		}
	});

	async function removeSubscription(key, sub, pdf) {
		const cart_section = document.querySelector('.shopify-section--cart');

		cart_section.classList.add('cart-section--loading');

		if(pdf != '') {
			let res = await fetch('/cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					items: [{
						id: pdf,
						quantity: 1,
						instructions: {
							can_update_quantity: false
						},
						parent_line_key: key
					}]
				})
			});

			await res.json();
		}

		let response = await fetch('/cart/change.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				id: sub,
				// selling_plan: '',
				quantity: 0,
				sections: [cart_section_id]
			})
		});
		let main = await response.json();

		cart_section.outerHTML = main.sections[cart_section_id];
	}

	async function updateShopifyCart(key, quantity) {
		const cart_section = document.querySelector('.shopify-section--cart');

		cart_section.classList.add('cart-section--loading');
		let updates = {};
		updates[key] = quantity;
		
		if(quantity > 0) {
			let response = await fetch('/cart.json');
			response = await response.json();

			for( let i = 0; i < response.items.length; i++ ){
				if(typeof response.items[i]['parent_relationship'] != 'undefined' && response.items[i]['parent_relationship']['parent_key'] == key) {
					updates[response.items[i].key] = quantity;
				}
			}
		}

		let main = await fetch('/cart/update.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				updates: updates,
				sections: [cart_section_id]
			})
		});

		response = await main.json();
		cart_section.outerHTML = response.sections[cart_section_id];
	}

			// $(".PDF").each(function () {
			// 	let $input = $(this);
			// 	let lineItemKey = $input.data("line");
			// 	// If quantity is greater than 1, reset to 1 on page load
			// 	if (parseInt($input.val()) > 1) {
			// 		updateCartQuantity(lineItemKey, 1);
			// 	}

			// });

			// function updateCartQuantity(lineItemKey, quantity) {
			// 	$.ajax({
			// 		type: "POST",
			// 		url: "/cart/change.js",
			// 		data: { line: lineItemKey, quantity: quantity },
			// 		dataType: "json",
			// 		success: function (cart) {
			// 			console.log("Cart updated:", cart);
			// 			location.reload(); // Reload cart to reflect changes
			// 		},
			// 		error: function (error) {
			// 			console.error("Error updating cart:", error);
			// 		}
			// 	});
			// }

	// window.addEventListener('DOMContentLoaded', function () {
	// 	$(".mainone").on("click", function (e) {
	// 		$(this).parents(".single").addClass("is-loading");

	// 		var main_datee = $(this).data("time");

	// 		e.preventDefault();
	// 		console.log(main_datee);
	// 		var itemsArray = [];

	// 		$(".single").each(function () {
	// 			if ($(this).hasClass("timestam")) {
	// 				var datee = $(this).data("time");
	// 				var variant = $(this).data("id");

	// 				if (main_datee == datee) {
	// 					itemsArray.push(variant);
	// 				}
	// 			}
	// 		});

	// 		var qty = 0;
	// 		var data = {
	// 			updates: {}
	// 		};

	// 		for (var i = 0; i < itemsArray.length; i++) {
	// 			data.updates[itemsArray[i]] = qty;
	// 		}
	// 		jQuery.ajax({
	// 			type: "POST",
	// 			url: "/cart/update.js",
	// 			data: data,
	// 			dataType: "json",
	// 			success: Shopify.onSuccess,
	// 			error: Shopify.onError
	// 		});
	// 	});
	// });

  } catch(e) { console.error(e); }
})();
})();
